import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';
import { getTenantSlugFromHostname } from '../utils/subdomain';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1️⃣ Load User
  const loadUser = async () => {
    const token = localStorage.getItem('token');

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      api.defaults.headers.common['x-auth-token'] = token;
      const tenantSlug = getTenantSlugFromHostname();
      const res = await api.get('/auth/user', {
        params: tenantSlug ? { tenantSlug } : {}
      });
      setUser(res.data);
    } catch (err) {
      console.error("Auth Error", err);
      // Remove invalid token, but KEEP device_token
      localStorage.removeItem('token');
      delete api.defaults.headers.common['x-auth-token'];
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // 2️⃣ Run on startup
  useEffect(() => {
    loadUser();
  }, []);

  // 3️⃣ Login
  const login = async (token) => {
    localStorage.setItem('token', token);
    api.defaults.headers.common['x-auth-token'] = token;
    await loadUser();
  };

  // 4️⃣ Logout
  const logout = () => {
    // ✅ CORRECT: Only remove the session token.
    // Do NOT use localStorage.clear() because we want to keep 'device_token'
    localStorage.removeItem('token');
    delete api.defaults.headers.common['x-auth-token'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
};